import { findNode, addClass, removeClass } from './utils'
const REQUIRE = '--REQUIRE--'

export default {
  created () {
    // 监听form中所有数据的变化
    if (!this.form) return
    Object.keys(this.form).forEach(key => {
      this.$watch(`form.${key}`, () => {
        this.isDisabled = !this.validateWithoutTip(this.rules)
      })
    })
  },

  mounted () {
    // this.validator(this.$refs['form'], this.rules)
  },

  methods: {
    validator ($form, rules) {
      Object.keys(rules).forEach(key => {
        const node = $form.querySelector(`[name="${key}"]`)
        if (!node) throw Error(`[Warning] 请给表单元素添加name属性${key}`)

        this.initValidateFormItem(node, key, rules)
      })
    },
        
    // 初始化每个表单验证的每个元素
    initValidateFormItem (node, key, rules) {
      // 在form-item中新建一个用来错误提示div
      const $item = findNode(node, 'form-item')
      let $tip = $item.querySelector('.form-tip')
      if (!$tip) {
        $tip = document.createElement('div')
        $item.appendChild($tip)
        $tip.className = 'form-tip'
      }

      // 把分散的事件集中起来处理，每一个元素只生成一个同类型的事件监听
      const triggers = {}

      rules[key].forEach(rule => {
        const index = rule.trigger || 'blur'

        if (!triggers[index]) {
          triggers[index] = [rule]
        } else {
          triggers[index].push(rule)
        }
      })

      Object.keys(triggers).forEach(trigger => {
        node.addEventListener(trigger, () => {
          const validateExec = () => {
            const ruleList = triggers[trigger]

            for (let i = 0, len = ruleList.length; i < len; i++) {
              const message = this.executeRule(ruleList[i], this.form[key], trigger)
              if (message) {
                if (message !== REQUIRE) {
                  $tip.innerText = message
                  addClass($tip, 'visible')
                  addClass($item, 'underline-danger')
                  ruleList[i].error && ruleList[i].error(this.form[key])
                }
                break
              } else {
                removeClass($tip, 'visible')
                removeClass($item, 'underline-danger')
              }
            }
    
            if (triggers === 'blur') {
              removeClass($item, 'underline-danger')
            }
          }

          // 把blur加入微任务队列
          if (trigger === 'blur') {
            setTimeout(() => {
              validateExec()
            }, 0)
          } else {
            validateExec()
          }
        })
      })

      node.addEventListener('focus', () => {
        removeClass($tip, 'visible')
        removeClass($item, 'underline-danger')
        addClass($item, 'underline-focus')
      })
    },

    validate ($form, rules) {
      let status = true

      const rulesKeyArr = Object.keys(rules)
      for (let key of rulesKeyArr) {
        const node = $form.querySelector(`[name="${key}"]`)
        /**
         * 由于联动导致dom节点不存在，所以该节点就不校验
         * @author long.li
         * @date 2021年03月31日
         */
        if (!node) continue
        const $item = findNode(node, 'form-item')
        const $tip = $item.querySelector('.form-tip')
        removeClass($item, 'underline-danger')
        removeClass($tip, 'visible')

        for (let i = 0, len = rules[key].length; i < len; i++) {
          const message = this.executeRule(rules[key][i], this.form[key])
          if (message) {
            if (message !== REQUIRE) {
              $tip.innerText = message
              addClass($tip, 'visible')
              addClass($item, 'underline-danger')
              this.$message(message)
              rules[key][i].error && rules[key][i].error(this.form[key])
            }
            status = false
            break
          }
        }
        // 按顺序单一验证
        if (!status) return status
      }

      return status
    },

    // 移除单一元素的校验规则
    removeValidateField ($form, rules, name) {
      const node = $form.querySelector(`[name="${name}"]`)
      const $item = findNode(node, 'form-item')
      const $tip = $item.querySelector('.form-tip')

      removeClass($item, 'underline-danger')
      removeClass($tip, 'visible')
    },

    validateWithoutTip (rules, customError) {
      let status = true

      Object.keys(rules).forEach(key => {
        for (let i = 0, len = rules[key].length; i < len; i++) {
          const message = this.executeRule(rules[key][i], this.form[key])
          if (message) {
            status = false
            customError && customError(message === REQUIRE ? rules[key][i].message : message)
            break
          }
        }
      })

      return status
    },
        
    // 执行规则
    executeRule (rule, value, trigger = '') {
      // require 校验
      if (rule.require && !value) return rule.message
      // 如果没有值，其他的校验就不进行了
      if (!value) return ''
      // 自定义函数校验 - 返回字符串就表示校验结果不正确
      if (rule.handler && typeof rule.handler === 'function') {
        return rule.handler(value, trigger) ? '' : rule.message
      }
      // 正则表达式校验
      if (rule.regular && !rule.regular.test(value)) return rule.message

      return ''
    }
  }
}
